import React, { useEffect, useState } from 'react';
import { Button, Title } from '@gerdau/hefesto';

import { StartValidationContainer, StartValidationJumbotron } from './styles';

import { StepPropsStartValidation } from '../types';
import { UserEvaluationService } from '../../../services/UserEvaluation';
import UserData from '../UserData';
import { useUserEvaluationContext } from '../../../providers/userEvaluation.provider';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../../store';
import { addToast } from '../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../store/ducks/toast/types';
import { UserEvaluationTitle, UserEvaluationRow } from '../styles';

const StartValidation: React.FC<StepPropsStartValidation> = ({ onNext }) => {
  const { userData, setLoading, loading } = useUserEvaluationContext();
  const userEvaluationService = new UserEvaluationService();
  const userName = useSelector((state: ApplicationState) => state.user.name);
  const [title, setTitle] = useState('');
  const dispatch = useDispatch();

  useEffect(() => setTitle(`Olá, ${userName}.`), [userName]);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const result = await userEvaluationService.validateUserData({
        cnpj: userData!.cnpj,
        email: userData!.email,
        prospectUserId: userData!.prospectUserId,
        requester: userData!.requester,
        token: userData!.token
      });
      onNext(result ? 'success' : 'fallback');
    } catch (error) {
      dispatch(
        addToast({
          message: 'Por favor, tente novamente mais tarde.',
          type: EToastTypes.DANGER,
          durationInMS: 5000
        })
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <StartValidationContainer>
      <header>
        <UserEvaluationTitle>
          <Title level={3}>{title}</Title>
        </UserEvaluationTitle>
      </header>

      <section>
        <p className="item">
          {userData!.companyName} solicitou o acesso à área do cliente. Essa
          solicitação possui o prazo de 7 dias corridos para ser analisada.
        </p>
      </section>

      <StartValidationJumbotron>
        <header>
          <p className="title">
            <strong>Solicitação de cadastro</strong>
          </p>
        </header>

        <div className="jumbotronContent">
          <UserEvaluationRow>
            <UserData user={userData!} showHeader={false} />
          </UserEvaluationRow>
        </div>
        <footer>
          <Button
            onClick={onSubmit}
            variant="primary"
            fullWidth
            name="startValidation"
            disabled={loading}
          >
            Analisar solicitação
          </Button>
        </footer>
      </StartValidationJumbotron>
    </StartValidationContainer>
  );
};

export default StartValidation;
